import React from 'react';
import logo from '../assets/logo.png';
import './Footer.css';

const quickLinks = ['Home', 'About Us', 'Services', 'Industries', 'Clients', 'Contact Us'];
const serviceLinks = ['Skilled Manpower', 'Housekeeping', 'Labour Contract', 'Material Handling', 'Driver Services', 'Recruitment'];

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const linkMap = {
    'Home': 'home', 'About Us': 'about', 'Services': 'services',
    'Industries': 'industries', 'Clients': 'clients', 'Contact Us': 'contact',
  };

  return (
    <footer className="footer">
      <div className="container footer-grid">
        {/* Brand */}
        <div className="footer-brand">
          <button className="footer-logo" onClick={() => scrollTo('home')}>
            <div className="footer-logo-icon">SS</div>
            <div>
              <div className="fl-name">Shri Sai Manpower Services</div>
              <div className="fl-sub">Est. 2017</div>
            </div>
          </button>
          <p className="footer-desc">
            Trusted industrial manpower and facility services provider since 2017.
            Serving Chakan, Talegaon & Bhosari MIDC with 200+ trained workforce.
          </p>
          <div className="social-links">
            <a href="https://facebook.com" className="social-btn" target="_blank" rel="noreferrer" aria-label="Facebook">📘</a>
            <a href="https://wa.me/919689100663" className="social-btn" target="_blank" rel="noreferrer" aria-label="WhatsApp">💬</a>
            <a href="mailto:shrisaimanpowerservices7@gmail.com" className="social-btn" aria-label="Email">✉️</a>
            <a href="tel:+919689100663" className="social-btn" aria-label="Call">📞</a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {quickLinks.map((l) => (
              <li key={l}>
                <button onClick={() => scrollTo(linkMap[l])} className="footer-link">{l}</button>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            {serviceLinks.map((s) => (
              <li key={s}>
                <button onClick={() => scrollTo('services')} className="footer-link">{s}</button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4>Contact Info</h4>
          <ul>
            <li><a href="tel:+919689100663" className="footer-link">+91 96891 00663</a></li>
            <li><a href="tel:+919767577713" className="footer-link">+91 97675 77713</a></li>
            <li>
              <a href="mailto:shrisaimanpowerservices7@gmail.com" className="footer-link" style={{ fontSize: '12px' }}>
                shrisaimanpowerservices7@gmail.com
              </a>
            </li>
            <li className="footer-addr">Chakan, Pune,<br />Maharashtra 410505</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom container">
        <p>© 2026 <span className="orange">Shri Sai Manpower Services</span>. All Rights Reserved.</p>
        <p>Designed & Developed by <a href="https://chintamanisoftsolutions.com" target="_blank" rel="noreferrer" style={{color:'var(--gold)',fontWeight:600,textDecoration:'none'}}>Shree Chintamani Soft Solutions</a></p>
      </div>
    </footer>
  );
};

export default Footer;
